var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7592 8.34921C20.1187 8.76854 20.0701 9.39984 19.6508 9.75926L12.6508 15.7593C12.2763 16.0803 11.7237 16.0803 11.3492 15.7593L4.34919 9.75926C3.92986 9.39984 3.8813 8.76854 4.24073 8.34921C4.60015 7.92988 5.23145 7.88132 5.65077 8.24075L12 13.6829L18.3492 8.24075C18.7685 7.88132 19.3998 7.92989 19.7592 8.34921Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS43NTkyIDguMzQ5MjFDMjAuMTE4NyA4Ljc2ODU0IDIwLjA3MDEgOS4zOTk4NCAxOS42NTA4IDkuNzU5MjZMMTIuNjUwOCAxNS43NTkzQzEyLjI3NjMgMTYuMDgwMyAxMS43MjM3IDE2LjA4MDMgMTEuMzQ5MiAxNS43NTkzTDQuMzQ5MTkgOS43NTkyNkMzLjkyOTg2IDkuMzk5ODQgMy44ODEzIDguNzY4NTQgNC4yNDA3MyA4LjM0OTIxQzQuNjAwMTUgNy45Mjk4OCA1LjIzMTQ1IDcuODgxMzIgNS42NTA3NyA4LjI0MDc1TDEyIDEzLjY4MjlMMTguMzQ5MiA4LjI0MDc1QzE4Ljc2ODUgNy44ODEzMiAxOS4zOTk4IDcuOTI5ODkgMTkuNzU5MiA4LjM0OTIxWiIgZmlsbD0iIzA0MDQwNSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };